import styled from 'styled-components';
import { Form, Input } from '@rocketseat/unform';
import { Link } from 'react-router-dom';

export const PageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f9fafb;
  position: relative;
`;

export const BackgroundImage = styled.div`
  position: absolute;
  inset: 0;
  overflow: hidden;
  z-index: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.8;
  }
`;

export const LoginCard = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 420px;
  padding: 2.5rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
`;

export const Logo = styled.div`
  text-align: center;
  margin-bottom: 2rem;

  img {
    max-width: 180px; /* Adjust based on your logo's aspect ratio */
    height: auto;
  }
`;

export const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Label = styled.label`
  font-size: 0.875rem;
  font-weight: 500;
  color: #4a5568;
`;

export const StyledInput = styled(Input)`
  padding: 0.75rem 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 0.875rem;
  transition: all 0.2s;

  &:focus {
    outline: none;
    border-color: #3182ce;
    box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.2);
  }
`;

export const RememberMe = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: #4a5568;
`;

export const SubmitButton = styled.button`
  padding: 0.75rem;
  background-color: #3182ce;
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #2c5282;
  }

  &:disabled {
    background-color: #a0aec0;
    cursor: not-allowed;
  }
`;

export const ForgotPassword = styled(Link)`
  font-size: 0.875rem;
  color: #3182ce;
  text-decoration: none;
  transition: color 0.2s;

  &:hover {
    color: #2c5282;
    text-decoration: underline;
  }
`;

export const FooterText = styled.p`
  margin-top: 1.5rem;
  text-align: center;
  font-size: 0.875rem;
  color: #718096;

  a {
    color: #3182ce;
    text-decoration: none;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }
`;

// // export const LoginContainer = styled.div`
// //   max-width: 400px;
// //   background: #fff;
// //   border-radius: 4px;
// //   box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
// //   padding: 30px;
// //   margin: 80px auto;

// //   h1 {
// //     text-align: center;
// //     min-width: 100%;
// //     font-size: 20px;
// //   }
// // `;

// export const Form = styled.form`
//   display: flex;
//   flex-direction: column;
//   justify-content: space-between;
//   height: 100px;

//   align-items: center;
//   margin-top: 30px;

//   input {
//     flex: 1;
//     border: 1px solid #eee;
//     padding: 10px 15px;
//     border-radius: 4px;
//     font-size: 12px;
//   }
// `;

// export const User = styled.div`
//   display: flex;
//   flex-direction: row;
//   align-items: center;

//   svg {
//     margin-right: 10px;
//     font-size: 16px;
//   }
// `;

// export const Password = styled.div`
//   display: flex;
//   flex-direction: row;
//   align-items: center;

//   svg {
//     margin-right: 10px;
//     font-size: 16px;
//   }
// `;

// // export const SubmitButton = styled.button`
// //   border: 0;
// //   padding: 0 15px;
// //   background-color: #ccc;
// //   color: #eee;
// //   font-weight: bold;
// //   text-transform: uppercase;
// //   border-radius: 0.25rem;
// // `;
